import {ElementStyles} from "./ElementStyles";
import {useState} from "react";
import deleteIcon from "../../img/delete.png";

const styles={
  container: {
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    minHeight: ElementStyles.height,
    display: "flex",
    alignItems: "center",
    textWrap: "noWrap",
    justifyContent: "space-between"
  },
  tooltip: {
    position: "absolute",
    borderRadius: ElementStyles.borderRadius,
    boxSizing: "inherit",
    color: ElementStyles.color,
    padding: ElementStyles.paddingLabels,
    minHeight: ElementStyles.height,
    alignItems: "center",
    whiteSpace: "pre",
    background: ElementStyles.color3,
    zIndex: 1
  }
}
export default function LabelWeex({children, style = null, tooltip, onDelete, ...props}){
  const [visible, setVisible] = useState("none")
  const [pos, setPos] = useState(0)

  return (
    <div onMouseEnter={(e) => {
      setVisible("block");
      const rect = e.target.getBoundingClientRect();
      setPos(rect.bottom + window.scrollY);
    }} onMouseLeave={() => setVisible("none")}
    >
      <label style={{...styles.container, ...style}} {...props}>
        {children}
        {onDelete&&visible==="block"&&<img className={"icon"} src={deleteIcon} style={{cursor: "pointer", height: "2rem", width: "auto"}}
              alt={"delete"} onClick={onDelete}/>}
      </label>
      {tooltip && <span style={{display: visible, ...styles.tooltip, top: pos}}>{tooltip}</span>}
    </div>
  );
};

